export default __webpack_public_path__ + "static/media/choose5.f9b3b766.png";